'use client';

import React, { Dispatch, useEffect, useRef } from 'react';

import { IBranch } from '@/_types';
import YandexMap from './components/Yandex';
import './style.css';
import NearestBranchControl from './components/NearestBranchControl';
import { ISavedBranch } from '@/_store/types';

function Desktop({
  data,
  selectedBranch,
  setSelectedBranch,
  activeShipperId,
}: {
  data: IBranch[];
  selectedBranch?: ISavedBranch | null;
  setSelectedBranch?: Dispatch<IBranch>;
  activeShipperId?: string;
}) {
  const mapRef = useRef<any>(null);

  const pointTo = (branch: IBranch | null) => {
    if (!mapRef.current || !branch) return;

    const adjustedLat = branch.location.lat - 0.0005;
    const adjustedLong = branch.location.long - 0.0002;

    mapRef.current.setCenter([adjustedLat, adjustedLong], 18, {
      duration: 300,
    });
  };
  useEffect(() => {
    if (selectedBranch && mapRef.current) {
      mapRef.current?.setCenter(
        [selectedBranch.location.lat, selectedBranch.location.long],
        18,
        { duration: 300 }
      );
    }
  }, [selectedBranch]);

  const onBranchClick = (branch: IBranch | null) => {
    if (branch) {
      setSelectedBranch?.(branch);
      if (mapRef.current) {
        mapRef.current?.setCenter(
          [branch.location.lat, branch.location.long],
          18,
          {
            duration: 300,
          }
        );
      }
    }
  };
  return (
    <>
      <YandexMap
        mapRef={mapRef}
        data={data}
        activeShipperId={activeShipperId}
        onSelect={(branch) => {
          pointTo(branch);
          onBranchClick(branch);
        }}
      />
      <NearestBranchControl
        onSelectBranch={(branch) => {
          pointTo(branch);
          onBranchClick(branch);
        }}
      />
    </>
  );
}

export default Desktop;
